module.exports = __webpack_public_path__ + "img/quinta.5e4100eb.png";